import { keyframes, styled, css } from 'styled-components';

import { hex2rgba } from '@/js/libs/ui';

import { ARROW_SIZE } from './position';

const fadeIn = () => keyframes`
  from {
    opacity: 0;
    transform: translateY(23px) scale(0);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const fadeOut = () => keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(23px) scale(0);

  }
`;

export const Arrow = styled.div<{ $visible: boolean; $position?: string; $dragging?: boolean }>`
  position: fixed;
  ${({ $position }) =>
    $position ??
    css`
      bottom: 94px;
      right: 48px;
    `}
  width: ${ARROW_SIZE}px;
  height: ${ARROW_SIZE}px;
  cursor: ${({ $dragging }) => ($dragging ? 'grabbing' : 'pointer')};
  z-index: 99;
  background: ${({ theme }) => hex2rgba(theme.colors.black_1, 0.3)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  touch-action: none;
  user-select: none;
  animation: ${({ $visible, $dragging }) => ($dragging ? 'none' : $visible ? fadeIn : fadeOut)} 0.16s ease;
  transform-origin: 50%;
  ${({ theme }) => theme.shadows.shadowTuna};
`;
